import { Text } from '@backstage/ui';

import { ActivityItem } from '@spotify/plugin-confidence-activity-react';

import { DeltaText } from '../DeltaText';
import type { Rule } from './types';

export const StateSection = ({
  oldRule,
  newRule,
}: {
  oldRule?: Rule;
  newRule?: Rule;
}) => {
  const oldState = oldRule?.enabled ? 'Active' : 'Inactive';
  const newState = newRule?.enabled ? 'Active' : 'Inactive';

  return (
    <ActivityItem.Section label="State">
      {oldRule && newRule && oldState !== newState ? (
        <DeltaText
          variant="body-medium"
          oldText={oldState}
          newText={newState}
          disableDiff
        />
      ) : (
        <Text variant="body-medium">{newState}</Text>
      )}
    </ActivityItem.Section>
  );
};
